import { useState } from "react";


export interface ImageFile {
    filename: string
    originFilename: string
    url: string
    isCompleted: boolean
}


export const useImagesViewerStates = () => {
  // OCR読み取り画像データ
  const [imagesList, setImagesList] = useState<ImageFile[]>([]);

  // エラーダイアログ表示フラグ情報
  const [isShowErrorDialog, setIsShowErrorDialog] = useState({
    isError: false,
    errorMessage: "",
    errorCode: "",
  });

  return {
    imagesList,
    setImagesList,
    isShowErrorDialog,
    setIsShowErrorDialog,
  };
};
